import { KeyRound } from "lucide-react";
import { useState } from "react";

import { api, formatApiError } from "@/lib/api";


export default function AccountPage() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const changePassword = async (event) => {
    event.preventDefault();
    setError("");
    setNotice("");
    setIsSubmitting(true);
    try {
      await api.post("/auth/change-password", form);
      setForm({ current_password: "", new_password: "", confirm_password: "" });
      setNotice("Password berhasil diperbarui.");
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="workspace" data-testid="account-page">
      <section className="page-heading"><div><p className="eyebrow">KEAMANAN AKUN</p><h1 data-testid="account-page-title">Ganti password</h1></div></section>
      <section className="form-section compact" aria-labelledby="change-password-title">
        <div className="section-heading"><div><KeyRound aria-hidden="true" size={19} /><h2 id="change-password-title">Password akun</h2></div></div>
        <form className="auth-form" data-testid="change-password-form" onSubmit={changePassword}>
          <label htmlFor="current-password">Password saat ini</label>
          <input autoComplete="current-password" data-testid="current-password-input" id="current-password" minLength="8" onChange={(event) => setForm({ ...form, current_password: event.target.value })} required type="password" value={form.current_password} />
          <label htmlFor="new-password">Password baru</label>
          <input autoComplete="new-password" data-testid="new-password-input" id="new-password" minLength="12" onChange={(event) => setForm({ ...form, new_password: event.target.value })} required type="password" value={form.new_password} />
          <label htmlFor="confirm-password">Konfirmasi password baru</label>
          <input autoComplete="new-password" data-testid="confirm-password-input" id="confirm-password" minLength="12" onChange={(event) => setForm({ ...form, confirm_password: event.target.value })} required type="password" value={form.confirm_password} />
          {error && <p className="form-error" data-testid="change-password-error" role="alert">{error}</p>}
          {notice && <p className="form-success" data-testid="change-password-success">{notice}</p>}
          <button data-testid="change-password-submit-button" disabled={isSubmitting} type="submit">{isSubmitting ? "Menyimpan…" : "Ganti password"}</button>
        </form>
      </section>
    </main>
  );
}